import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import GuestDetails from "../views/GuestDetails.vue";
import Vehicles from "../views/Vehicles.vue";
import Extras from "../views/Extras.vue";
import TravelAndInsurance from "../views/TravelAndInsurance.vue";
import DiscountsAndOffers from "../views/DiscountsAndOffers.vue";
import SummaryAndConfirmation from "../views/SummaryAndConfirmation.vue";
import store from "../store/index";

// Empty component for server-rendered pages
const ServerRenderedPage = { template: "<div></div>" };

// New flow order (June 2026): Availability(0) → Extras(1) → Travel &
// Insurance(2) → Discounts(3) → Guest Details + Vehicles(4) → Summary(5).
// Guard thresholds must match the CHANGE_PROGRESS_STEP values committed
// by each view's continue handler.
const routes = [
    {
        path: "/",
        redirect: "/availability"
    },
    {
        path: "/availability",
        name: "Home",
        component: Home
    },
    {
        path: "/extras",
        name: "Extras",
        component: Extras,
        beforeEnter: (to, from, next) => {
            // NB: env vars are inlined as strings — "0" is truthy, so compare
            // explicitly (the old `!process.env.VUE_APP_DEBUG` never guarded)
            if (
                store.state.progressStep < 1 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/travel-and-insurance",
        name: "TravelAndInsurance",
        component: TravelAndInsurance,
        beforeEnter: (to, from, next) => {
            if (
                store.state.progressStep < 2 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/discounts-and-offers",
        name: "DiscountsAndOffers",
        component: DiscountsAndOffers,
        beforeEnter: (to, from, next) => {
            if (
                store.state.progressStep < 3 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/guest-details",
        name: "GuestDetails",
        component: GuestDetails,
        beforeEnter: (to, from, next) => {
            if (
                store.state.progressStep < 4 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/vehicles",
        name: "Vehicles",
        component: Vehicles,
        beforeEnter: (to, from, next) => {
            if (
                store.state.progressStep < 4 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/summary-and-confirmation",
        name: "SummaryAndConfirmation",
        component: SummaryAndConfirmation,
        beforeEnter: (to, from, next) => {
            if (
                store.state.progressStep < 5 &&
                process.env.VUE_APP_DEBUG != 1
            ) {
                next({
                    path: "/availability"
                });
            } else {
                next();
            }
        }
    },
    {
        path: "/booking/stripe-success/:currency",
        name: "StripeSuccess",
        component: ServerRenderedPage
    },
    {
        path: "/booking/stripe-cancel/:currency",
        name: "StripeCancel",
        component: ServerRenderedPage
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // console.log('to',to);
        // console.log('from',from);
        // console.log('savedPosition',savedPosition);
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {
                el: to.hash
            };
        }
        return {
            x: 0,
            y: 0
        };
    }
});

export default router;
